var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel',{attrs:{"id":"carousel-example-generic","controls":"","indicators":""}},_vm._l((_vm.images),function(image){return _c('b-carousel-slide',{key:image.IdImage,attrs:{"img-src":image.image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }